export default __webpack_public_path__ + "0ff1cd1ff11e2d8169588f92c5be1188.jpg";